import { render } from "./ShootingPin.vue?vue&type=template&id=25de0f10&ts=true"
import script from "./ShootingPin.vue?vue&type=script&lang=ts"
export * from "./ShootingPin.vue?vue&type=script&lang=ts"

import "./ShootingPin.vue?vue&type=style&index=0&id=25de0f10&lang=scss"

import exportComponent from "/www/public/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__